import type {ApiTemplate} from '../api-types';
import {AUTOMATIC_PRICING_GROUP_ID} from '../constants';
import type {InitialBillingFrequency, Template} from '../types';

export const transformApiTemplateToTemplate = (apiTemplate: ApiTemplate): Template => {
    const billingFrequency = (): InitialBillingFrequency => {
        switch (apiTemplate.billingFrequency) {
            case 'weekly':
                return 'weekly';
            case 'monthly':
                return 'monthly';
            case 'biweekly':
                return 'biweekly';
            default:
                return 'monthly';
        }
    };

    return {
        id: apiTemplate.templateId,
        title: apiTemplate.name,
        tuitions: apiTemplate.tuitionIds.map(id => ({id})),
        fees: apiTemplate.feeIds,
        billingFrequency: billingFrequency(),
        pricing: {type: 'manual', pricingGroup: apiTemplate.pricingGroupId ?? AUTOMATIC_PRICING_GROUP_ID},
        discounts: apiTemplate.discountIds,
        type: 'template',
    };
};
